import { Role as TeamUserRole } from 'domains/models/team_user/role';
import { DisplayType as FormDisplayType } from 'domains/models/form/displayType';

export enum Role {
  Admin = 100,
  Editor = 200,
  Viewer = 300,
}

export const isFormCreatableUser = (teamUserRole: TeamUserRole): boolean => {
  if (teamUserRole <= TeamUserRole.Member) {
    return true;
  }
  return false;
};

export const isPrivateFormUpdatableUser = (role: Role): boolean => {
  if (role <= Role.Editor) {
    return true;
  }
  return false;
};

export const isFormUpdatableUser = (
  teamUserRole: TeamUserRole,
  role: Role | null,
): boolean => {
  if (teamUserRole <= TeamUserRole.Member) {
    return true;
  }
  if (role && role <= Role.Editor) {
    return true;
  }
  return false;
};

export const isPrivateFormCopyableUser = (role: Role): boolean => {
  if (role <= Role.Admin) {
    return true;
  }
  return false;
};

export const isFormCopyableUser = (
  teamUserRole: TeamUserRole,
  role: Role | null,
): boolean => {
  if (teamUserRole <= TeamUserRole.Admin) {
    return true;
  }
  if (role && role <= Role.Admin) {
    return true;
  }
  return false;
};

export const isPrivateFormDeletableUser = (role: Role): boolean => {
  if (role <= Role.Editor) {
    return true;
  }
  return false;
};

export const isFormDeletableUser = (
  teamUserRole: TeamUserRole,
  role: Role | null,
): boolean => {
  if (teamUserRole <= TeamUserRole.Admin) {
    return true;
  }
  if (role && role <= Role.Editor) {
    return true;
  }
  return false;
};

export const isPrivateFormUserAddableUser = (role: Role): boolean => {
  if (role <= Role.Admin) {
    return true;
  }
  return false;
};

export const isFormUsesrAddableUser = (
  teamUserRole: TeamUserRole,
  role: Role | null,
): boolean => {
  if (teamUserRole <= TeamUserRole.Admin) {
    return true;
  }
  if (role && role <= Role.Admin) {
    return true;
  }
  return false;
};

export const isPrivateFormAnswerViewableUser = (role: Role): boolean => {
  if (role <= Role.Admin) {
    return true;
  }
  return false;
};

export const isFormAnswerViewableUser = (
  teamUserRole: TeamUserRole,
  role: Role | null,
): boolean => {
  if (teamUserRole === TeamUserRole.Restricted) {
    if (role && role <= Role.Admin) {
      return true;
    }
  }
  if (teamUserRole <= TeamUserRole.Admin) {
    return true;
  }
  if (role && role <= Role.Admin) {
    return true;
  }
  return false;
};

export const isPrivateFormViewableUser = (role: Role): boolean => {
  if (role <= Role.Viewer) {
    return true;
  }
  return false;
};

export const isFormViewableUser = (
  teamUserRole: TeamUserRole,
  role: Role | null,
): boolean => {
  if (teamUserRole === TeamUserRole.Restricted) {
    if (role && role <= Role.Viewer) {
      return true;
    }
  }
  if (teamUserRole <= TeamUserRole.Member) {
    return true;
  }
  if (role && role <= Role.Viewer) {
    return true;
  }
  return false;
};
